'use client'

import React from 'react'
import { sidebarStore } from '@/store/ui/sidebar.store'
import { useRouter } from 'next/navigation'
import { homeActionLog } from '@/modules/action-log/home'

export const LoopyHeader = () => {
  const { changeVisible } = sidebarStore()
  const router = useRouter()

  const handleClickOpenMenu = () => {
    homeActionLog.clickMenu()
    changeVisible({ visible: true })
  }

  const handleClickHome = () => {
    router.push('/loopy')
  }

  return (
    <div className="bg-pink-1 flex justify-between items-center sticky top-0 z-20 h-[56px] w-[100%] pt-[20px] pb-[20px] pl-[16px] pr-[16px]">
      <button className="flex items-center gap-[2px]" onClick={handleClickHome}>
        <img src="/img/logo.svg" />
        <img src="/img/close_thin.svg" />
        <img className="w-[61px] h-[24px]" src="/img/entertainment/loopy_logo.png" />
      </button>
      <button className="cursor-pointer" onClick={handleClickOpenMenu}>
        <img src="/img/menu.svg" />
      </button>
    </div>
  )
}
